import { view } from '@risingstack/react-easy-state'
import { Redirect } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import BudgetHeadsService from 'services/users/budget-heads.service'
import globalStore from 'store/index'
import ContentLoading from 'components/common/ContentLoading'
import LABELS from 'constants/labels'

import styled from 'styled-components'
import { PlusOutlined, InboxOutlined } from '@ant-design/icons'
import { Button, Input, message, Row, Col, Select, Modal, Upload, Tooltip, Popconfirm } from 'antd'
import dayjs from 'dayjs'

import StyledBox from 'components/common/styled-components/StyledBox'
import ConditionRow from 'components/budget-analysis/ConditionRow'
import WorkForcePeriodService from 'services/users/workforce-period.service'

import BudgetCriteriaHeadsService from 'services/users/budget-criteria-heads.service'
import BudgetValuesService from 'services/users/budget-values.service'
import { DatePicker } from '../../../../node_modules/antd/lib/index'
import moment from '../../../../node_modules/moment/moment'
import { changeTitle, setWorkforceFavicon, setHireReviewFavicon } from 'utils/header-meta'
import { ExportToExcel } from 'components/common/layouts/ExportToExcel'
import BudgetTentativeValuesService from 'services/users/budget-tentative-values.service'
import { getCurrentFiscalDateRange } from 'utils/dateRange'

const localizedFormat = require('dayjs/plugin/localizedFormat')
dayjs.extend(localizedFormat)

const StyledConfigurationFormBox = styled.div`
	& .input-box {
		margin: 10px 0px;
	}
	& .action-buttons.submit {
		margin-top: 20px;
	}
`

const blankCondition = {
	field: null,
	operator: null,
	values: null,
}

const AddPositionPage = () => {
	const [loading, setLoading] = useState(false)
	const [workforceBudgetHeadId, setWorkforceBudgetHeadId] = useState()
	const [criteria, setCriteria] = useState([[blankCondition]])
	const [createButtonLoading, setCreateButtonLoading] = useState(false)
	const [inputValues, setInputValues] = useState({})
	const [budgetCriteriaHeads, setBudgetCriteriaHeads] = useState([[]])
	const [rate, setRate] = useState(1)
	const [count, setCount] = useState(1)
	const [total, setTotal] = useState(0)
	const [frequency, setFrequency] = useState('annually')
	const [annualizedRate, setAnnualizedRate] = useState(0)
	const [proportioned, setProportioned] = useState(1)
	const dateFormat = 'DD-MMM-YYYY'
	const [dateRange, setDateRange] = useState(getCurrentFiscalDateRange)
	const [fileList, setFileList] = useState([])
	const [importVacancyModalVisible, setImportVacancyModalVisible] = useState(false)
	const [importingVacancy, setImportingVacancy] = useState(false)
	const [workforcePeriod, setWorkForcePeriod] = useState(null)
	const [workforcePeriodId, setWorkforcePeriodId] = useState(null)
	const [sampleFileData, setSampleFileData] = useState(null)
	const [currency, setCurrency] = useState()
	const [criteriaChildren, setCriteriaChildren] = useState([])
	const [createVia, setCreateVia] = useState('withoutApproval')
	const enableAllocationFeature = globalStore?.currentOrganization?.enable_allocation_feature
	const accessibleFeatures = globalStore.currentUser?.accessible_features || []
	const roles = globalStore.currentUser?.roles || []
	const wfmCurrentPeriod = globalStore.ui.configuration.currentWorkforcePeriod

	//Change title and favicon for SmartBudgets
	useEffect(() => {
		changeTitle(LABELS.workforcePageTitle)
		setWorkforceFavicon()

		return () => {
			changeTitle(LABELS.defaultPageTitle)
			setHireReviewFavicon()
		}
	}, [])

	useEffect(() => {
		setCurrency(globalStore.currentOrganization.currency || 'INR')
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [globalStore.currentOrganization.currency])

	useEffect(() => {
		if (wfmCurrentPeriod.workforce_period) {
			const startDate = wfmCurrentPeriod?.workforce_period?.start_date
				? moment.utc(wfmCurrentPeriod?.workforce_period?.start_date)
				: moment.utc().set('month', 3)
			const endDate = wfmCurrentPeriod?.workforce_period?.end_date
				? moment.utc(wfmCurrentPeriod?.workforce_period?.end_date)
				: moment.utc().set('month', 4).add(1, 'y')
			setDateRange([startDate, endDate])
		}
	}, [wfmCurrentPeriod, wfmCurrentPeriod.workforce_period])

	useEffect(() => {
		const pageState = globalStore.ui.configuration.budgetHeads.index

		const fetchBudgetHeads = async () => {
			setLoading(true)
			await BudgetHeadsService.index({ pageState })
			const { budget_heads } = pageState
			if (!budget_heads) {
				message.error('Budget Heads not found')
				return
			}
			const workforceBudgetHead = budget_heads.find((bh) => bh.name === 'Workforce Plan')
			setWorkforceBudgetHeadId(workforceBudgetHead?.id)
			setLoading(false)
		}

		fetchBudgetHeads()

		const fetchAllFieldsData = async () => {
			const pageState = globalStore.ui.configuration.budgetCriteriaHeads.criteria_head_list
			await BudgetCriteriaHeadsService.criteriaHeadList({ pageState })
			const { budget_criteria_heads } = pageState

			if (!budget_criteria_heads) {
				message.error('Budget criteria not found')
				return
			}
			setBudgetCriteriaHeads(budget_criteria_heads)
		}

		const fetchWorkforcePeriod = async () => {
			const pageState = globalStore.ui.configuration.workforcePeriod.index

			await WorkForcePeriodService.index({ pageState })

			const { serverStatus, workforcePeriodsErrors } = pageState
			if (serverStatus.status !== 200) {
				message.error('Oops!! something went wrong')
				return
			}

			if (workforcePeriodsErrors) {
				message.error(workforcePeriodsErrors[0] || "WorkForce Period couldn't be fetched.")
				return
			}
			const { workforce_periods } = pageState
			setWorkForcePeriod(workforce_periods)
		}

		fetchAllFieldsData()
		fetchWorkforcePeriod()
	}, [])

	useEffect(() => {
		if (criteriaChildren.length) {
			const updateCriteriaData = criteria[0].map((data) => {
				if (criteriaChildren.some((items) => items.name === data.field)) {
					return { ...data, values: null, operator: null }
				}
				return data
			})
			setCriteria([updateCriteriaData])
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [criteriaChildren])

	useEffect(() => {
		if (!roles.includes('super-admin') && accessibleFeatures.includes('initiate-budget-approval')) {
			setCreateVia('withApproval')
		}
	}, [accessibleFeatures, roles])

	useEffect(() => {
		const fetchSampleFile = async () => {
			const tempState = {}
			await BudgetValuesService.sampleFileData({
				pageState: tempState,
				budgetHeadId: workforceBudgetHeadId,
			})

			const { data, dataErrors } = tempState
			if (dataErrors) {
				message.error(dataErrors || 'Sample File could not be fetched.')
				return
			}
			setSampleFileData(data)
		}

		const fetchEssentialFieldsList = async () => {
			const tempState = {}
			await BudgetValuesService.essentialFieldsList({
				pageState: tempState,
				budgetHeadId: workforceBudgetHeadId,
			})

			const { budget_criteria_heads, dataErrors } = tempState
			if (dataErrors) {
				message.error(dataErrors || 'Sample File could not be fetched.')
				return
			}
			const formatCriteriaList = budget_criteria_heads?.map((data) => {
				const returnData = { field: data?.name, values: null, operator: null }
				return returnData
			})
			setCriteria(formatCriteriaList?.length ? [formatCriteriaList] : [[blankCondition]])
		}
		if (workforceBudgetHeadId) {
			fetchSampleFile()
			fetchEssentialFieldsList()
		}
	}, [workforceBudgetHeadId])

	// useEffect(() => {
	// 	const setCriteriaForAddPosition = () => {
	// 		const vacantCriteria = [[{ field: 'Position Status', values: ['Vacant'], operator: 'any' }]]
	// 		setCriteria(vacantCriteria)
	// 	}
	// 	setCriteriaForAddPosition()
	// }, [])

	const handleInputChange = (value, inputType) => {
		let newInputValues = null

		if (inputType === 'frequency') {
			newInputValues = { ...inputValues, [inputType]: value }
			setFrequency(value)
			setAnnualizedRate(getAnnualizedRate(rate, value))
			setTotal(getTotal(count, rate * getFrequencyDays(value), proportioned, value))
		} else {
			newInputValues = { ...inputValues, [inputType]: value }
		}

		if (inputType === 'rate') {
			setRate(value)
			setTotal(getTotal(count, getAnnualizedRate(value, frequency), proportioned, frequency))
			setAnnualizedRate(getAnnualizedRate(value, frequency))
		}

		if (inputType === 'unit') {
			setCount(value)
			setTotal(getTotal(value, annualizedRate, proportioned, frequency))
		}

		if (inputType === 'total_cost') {
			setTotal(value)
			setRate(value / count)
			setAnnualizedRate(getAnnualizedRate(value / count, frequency))
		}

		if (inputType === 'currency') {
			setCurrency(value)
		}

		setInputValues(newInputValues)
	}

	const handleDateChange = (range) => {
		if (range) {
			setDateRange([range[0], range[1]])

			setProportioned(getProportionedFactor(range[0], range[1]))

			setInputValues({
				...inputValues,
				start_date: dateRange[0],
				end_date: dateRange[1],
			})
			setTotal(
				getTotal(count, annualizedRate, getProportionedFactor(range[0], range[1]), frequency)
			)
		}
	}

	const getTotal = (count, annualizedRate, proportioned, frequency) => {
		if (frequency === 'one_time') {
			return Math.round(count * annualizedRate * 100) / 100
		} else {
			return Math.round(count * annualizedRate * proportioned * 100) / 100
		}
	}

	const getProportionedFactor = (startDate, endDate) => {
		return Math.round((getPeriodDays(startDate, endDate) / 365) * 100) / 100
	}

	const getAnnualizedRate = (rate, frequency) => {
		return rate * getFrequencyDays(frequency)
	}

	const getFrequencyDays = (frequency) => {
		if (frequency === 'daily') {
			return 365.0
		} else if (frequency === 'half_yearly') {
			return 2 // 2.027
		} else if (frequency === 'quarterly') {
			return 4 // 4.05
		} else if (frequency === 'monthly') {
			return 12 // 12.16
		} else if (frequency === 'weekly') {
			return 52 // 52.14
		} else if (frequency === 'annually') {
			return 1
		} else if (frequency === 'one_time') {
			return 1
		}
	}

	const getPeriodDays = (startDate, endDate) => {
		const oneDay = 24 * 60 * 60 * 1000
		const days = Math.round(Math.abs((endDate - startDate) / oneDay))
		return days + 1
	}

	const handleAddNewCondition = (conditionSetIndex, parentConditionIndex) => {
		setCriteria((prevCriteria) => {
			const newCriteria = prevCriteria.map((conditionSet, conSetIndex) => {
				if (conSetIndex !== conditionSetIndex) return conditionSet
				const newConditionSet = [...conditionSet]
				newConditionSet.splice(parentConditionIndex + 1, 0, blankCondition)
				return newConditionSet
			})

			return newCriteria
		})
	}

	const handleRemoveCondition = (conditionSetIndex, deletedConditionIndex) => {
		setCriteria((prevCriteria) => {
			const newCriteria = prevCriteria.map((conditionSet, conSetIndex) => {
				if (conSetIndex !== conditionSetIndex) return conditionSet
				const newConditionSet = [...conditionSet]
				newConditionSet.splice(deletedConditionIndex, 1)
				return newConditionSet
			})

			return newCriteria
		})
	}

	const handleCreateConditionValues = ({ conditionSetIndex, conditionIndex, condition }) => {
		if (!condition) return
		if (!condition.values) return

		setCriteria((prevCriteria) => {
			const newCriteria = prevCriteria.map((conditionSet, conSetIndex) => {
				if (conSetIndex !== conditionSetIndex) return conditionSet
				const newConditionSet = [...conditionSet]
				return newConditionSet.map((c, index) => {
					if (index !== conditionIndex) return c

					return condition
				})
			})

			return newCriteria
		})
	}

	const handleCreate = async () => {
		inputValues['currency'] = currency
		inputValues['rate'] = rate
		inputValues['unit'] = count
		inputValues['total_cost'] = total
		inputValues['start_date'] = dateRange[0].format()
		inputValues['end_date'] = dateRange[1].format()
		inputValues['frequency'] = frequency
		inputValues['annualized_amount'] = annualizedRate

		if (!inputValues['rate']) {
			message.error("Rate can't be blank")
			return
		}
		if (!inputValues['unit']) {
			message.error("Unit can't be blank")
			return
		}
		if (!inputValues['start_date']) {
			message.error("Start Date can't be blank")
			return
		}
		if (!inputValues['end_date']) {
			message.error("End Date can't be blank")
			return
		}
		if (!inputValues['frequency']) {
			message.error("Frequency can't be blank")
			return
		}

		if (count < 1 && !inputValues['position_code']) {
			message.error("Position Code can't be blank")
			return
		}

		const pageState = {}
		const tentativeData = {
			budget_value: {
				criteria: criteria.filter((c) => c.length > 0),
				...inputValues,
			},
		}

		const postData = {
			budget_tentative_value: {
				budget_head_id: workforceBudgetHeadId,
				tentative_data: tentativeData,
				budget_type: 'planned',
			},
		}

		setCreateButtonLoading(true)
		if (createVia === 'withApproval')
			await BudgetTentativeValuesService.create({
				pageState,
				values: postData,
			})
		else
			await BudgetValuesService.addPosition({
				pageState,
				values: tentativeData,
				budgetHeadId: workforceBudgetHeadId,
			})

		setCreateButtonLoading(false)

		const { serverStatus, budgetValueErrors } = pageState

		if (budgetValueErrors) {
			message.error(budgetValueErrors)
			return
		}

		if (serverStatus.status === 200) {
			message.success('Position created successfully.')
			setCriteria([[blankCondition]])
			setInputValues({})

			return
		}

		message.error('Oops!! something went wrong')
	}

	const handleImportVacancy = async () => {
		if (fileList.length === 0) return

		const tempState = {}

		const formData = new FormData()

		formData.append('file', fileList[0])
		formData.append('workforce_period_id', workforcePeriodId)

		setImportingVacancy(true)
		await BudgetValuesService.importVacancy({
			pageState: tempState,
			formData,
			budgetHeadId: workforceBudgetHeadId,
		})
		setImportingVacancy(false)

		setImportVacancyModalVisible(false)
		const { budgetValueErrors } = tempState

		if (budgetValueErrors) {
			message.error(budgetValueErrors || 'Import Failed')
			return
		}

		message.success('Import started. Kindly check import page in Report Center to see imported')
	}

	const handleSync = async (values) => {
		const pageState = globalStore.ui.configuration.budgetValues.workforce_sync
		await BudgetValuesService.sync({
			pageState,
			values,
		})

		const { serverStatus, budgetUtilizationErrors } = pageState
		if (budgetUtilizationErrors) {
			message.error(budgetUtilizationErrors || "Actual Budget couldn't be created.")
			return
		}

		if (serverStatus.status === 200) {
			message.success('Process Initiated')
			return
		}

		message.error('Oops!! something went wrong')
	}

	const openImportVacancyModal = () => {
		setImportVacancyModalVisible(true)
	}

	const uploadProps = {
		accept:
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
		onRemove: (file) => {
			const index = fileList.indexOf(file)
			const newFileList = fileList.slice()
			newFileList.splice(index, 1)

			setFileList(newFileList)
		},
		beforeUpload: (file) => {
			setFileList([file])
			return false
		},
		fileList,
	}

	const renderPageContent = () => {
		return (
			<StyledConfigurationFormBox>
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<h1>Planned Value for Workforce Plan</h1>
					<div className='action-buttons top'>
						<Tooltip title='Create or update multiple records by upload'>
							<Button onClick={openImportVacancyModal} style={{ marginRight: 10 }}>
								Import Planned Data
							</Button>
						</Tooltip>
						<Tooltip title='Sync hirereview with payreview'>
							<Popconfirm
								title='Sync for'
								okText='Active'
								cancelText='Inactive'
								placement='bottomLeft'
								onCancel={() => handleSync('inactive')}
								onConfirm={() => handleSync('active')}>
								<Button style={{ marginRight: 10 }}>Sync</Button>
							</Popconfirm>
						</Tooltip>
					</div>
				</div>
				<Row gutter={20}>
					<Col span={16}>
						<div className='input-box'>
							<div>
								<strong>
									Position Period <span style={{ color: 'red' }}>*</span>
								</strong>
							</div>
							<DatePicker.RangePicker
								format={dateFormat}
								value={dateRange}
								onChange={handleDateChange}
							/>
						</div>
					</Col>
					<Col span={8} pull={1}>
						<div className='input-box'>
							<strong>Proportioned Factor</strong>
							<Input placeholder='Proportioned Factor' value={proportioned} disabled={true} />
						</div>
					</Col>
					<Col span={2}>
						<div className='input-box'>
							<strong>Currency</strong>
							<Input
								placeholder='Currency'
								value={currency}
								onChange={(e) => handleInputChange(e.target.value, 'currency')}
							/>
						</div>
					</Col>
					<Col span={4}>
						<div className='input-box'>
							<strong>
								Headcount
								<span style={{ color: 'red' }}>*</span>
							</strong>
							<Input
								placeholder='Enter Count'
								value={count || inputValues['unit']}
								onChange={(e) => handleInputChange(e.target.value, 'unit')}
							/>
						</div>
					</Col>
					<Col span={5}>
						<div className='input-box'>
							<strong>
								Salary Rate per person
								<span style={{ color: 'red' }}>*</span>
							</strong>
							<Input
								placeholder='Enter Rate'
								value={rate || inputValues['rate']}
								onChange={(e) => handleInputChange(e.target.value, 'rate')}
							/>
						</div>
					</Col>
					<Col span={4}>
						<div className='input-box'>
							<strong>
								Frequency <span style={{ color: 'red' }}>*</span>
							</strong>
							<Select
								style={{ display: 'block' }}
								placeholder='Choose frequency'
								defaultValue={frequency}
								onChange={(value) => handleInputChange(value, 'frequency')}>
								<Select.Option value='daily'>Daily</Select.Option>
								<Select.Option value='weekly'>Weekly</Select.Option>
								<Select.Option value='monthly'>Monthly</Select.Option>
								<Select.Option value='quarterly'>Quarterly</Select.Option>
								<Select.Option value='half_yearly'>Half Yearly</Select.Option>
								<Select.Option value='annually'>Annually</Select.Option>
								<Select.Option value='one_time'>One Time</Select.Option>
							</Select>
						</div>
					</Col>
					<Col span={4}>
						<div className='input-box'>
							<strong>Annualised Rate</strong>
							<Input placeholder='Annualised Rate' value={annualizedRate} disabled={true} />
						</div>
					</Col>
					<Col span={4}>
						<div className='input-box'>
							<strong>Total Cost</strong>
							<Input
								placeholder='Total Cost'
								value={total || inputValues['total_cost']}
								onChange={(e) => handleInputChange(e.target.value, 'total_cost')}
							/>
						</div>
					</Col>
				</Row>
				<Row gutter={20}>
					<Col span={6}>
						<div className='input-box'>
							<strong>Budget Type</strong>
							<Select
								style={{ display: 'block' }}
								placeholder='Choose Budget Type'
								onChange={(value) => handleInputChange(value, 'budget_type')}>
								<Select.Option value='budgeted'>Budgeted</Select.Option>
								<Select.Option value='non_budgeted'>Non-budgeted</Select.Option>
							</Select>
						</div>
					</Col>
					<Col span={6}>
						<div className='input-box'>
							<div>
								<strong>
									Position Code <span style={{ color: 'red' }}>*</span>
								</strong>
							</div>
							<Input
								placeholder='Enter Position Code'
								value={inputValues['position_code']}
								disabled={count > 1}
								onChange={(e) => handleInputChange(e.target.value, 'position_code')}
							/>
						</div>
					</Col>
					<Col span={6}>
						<div className='input-box'>
							<strong>Position Name</strong>
							<Input
								placeholder='Enter Position Name'
								value={inputValues['position_name']}
								// disabled={count > 1}
								onChange={(e) => handleInputChange(e.target.value, 'position_name')}
							/>
						</div>
					</Col>
				</Row>
				{enableAllocationFeature && (
					<Row gutter={20}>
						<Col span={6}>
							<div className='input-box'>
								<strong>Allocation Percentage</strong>
								<Input
									placeholder='Enter Allocation Percentage'
									value={inputValues['allocation_percentage']}
									onChange={(e) => handleInputChange(e.target.value, 'allocation_percentage')}
								/>
							</div>
						</Col>
						<Col span={6}>
							<div className='input-box'>
								<strong>Increment Percentage</strong>
								<Input
									placeholder='Enter Increment Percentage'
									value={inputValues['increment_percentage']}
									onChange={(e) => handleInputChange(e.target.value, 'increment_percentage')}
								/>
							</div>
						</Col>
					</Row>
				)}
				<div className='input-box'>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						<strong>Criteria</strong>
						{criteria.filter((c) => c.length > 0).length === 0 && (
							<Button shape='circle' onClick={() => setCriteria([[blankCondition]])}>
								<PlusOutlined />
							</Button>
						)}
					</div>
					{criteria.map((conditionSet, conditionSetIndex) => {
						return (
							<div key={conditionSetIndex}>
								{conditionSet.map((condition, conditionIndex) => {
									return (
										<ConditionRow
											criteria={criteria}
											condition={condition}
											key={conditionIndex}
											conditionIndex={conditionSetIndex}
											clearChildren={setCriteriaChildren}
											lastInputGroup={conditionSet.length === conditionIndex + 1}
											conditionSetLength={conditionSet.length}
											firstInputGroup={conditionIndex === 0}
											inputGroupIndex={conditionIndex}
											updateConditionValues={(condition) =>
												handleCreateConditionValues({
													conditionSetIndex,
													conditionIndex,
													condition,
												})
											}
											addNewCondition={() =>
												handleAddNewCondition(conditionSetIndex, conditionIndex)
											}
											removeCondition={() =>
												handleRemoveCondition(conditionSetIndex, conditionIndex)
											}
											budgetCriteriaHeads={budgetCriteriaHeads}
										/>
									)
								})}
							</div>
						)
					})}
				</div>
				<div className='action-buttons submit'>
					{roles.includes('super-admin') && (
						<>
							<strong>Create Position via :</strong>
							<Select
								style={{ margin: '0 20px' }}
								placeholder='Choose'
								value={createVia}
								onChange={(value) => setCreateVia(value)}>
								<Select.Option value='withoutApproval'>Without Approval</Select.Option>
								<Select.Option value='withApproval'>With Approval</Select.Option>
							</Select>
						</>
					)}
					<Button type='primary' loading={createButtonLoading} onClick={handleCreate}>
						{createVia === 'withApproval' ? 'Send Position for Approval' : 'Add Position'}
					</Button>
				</div>
			</StyledConfigurationFormBox>
		)
	}

	if (
		accessibleFeatures?.length > 0 &&
		!['criteria-edit', 'wfm-position-edit', 'budget-data-edit'].every((featureKey) =>
			accessibleFeatures.includes(featureKey)
		)
	)
		return <Redirect to='/' />

	if (loading) {
		return <ContentLoading />
	}

	if (workforceBudgetHeadId)
		return (
			<div className='page-content dashboard-page'>
				<StyledBox>{renderPageContent()}</StyledBox>
				<Modal
					title='Import Planned Data'
					visible={importVacancyModalVisible}
					confirmLoading={importingVacancy}
					closable={false}
					maskClosable={false}
					destroyOnClose
					onOk={handleImportVacancy}
					okText='Import'
					onCancel={() => setImportVacancyModalVisible(false)}>
					<Upload.Dragger {...uploadProps}>
						<p className='ant-upload-drag-icon'>
							<InboxOutlined />
						</p>
						<p className='ant-upload-text'>Click or drag file to this area to upload</p>
						<p className='ant-upload-hint'>
							Please ensure data accuracy in your file for upload. After upload, each associated
							records will be updated directly.
						</p>
					</Upload.Dragger>
					{workforcePeriod && (
						<Select
							placeholder='Select Workforce Period'
							onChange={(value) => setWorkforcePeriodId(value)}
							style={{ width: '98%', padding: '20px 0 10px 10px' }}>
							{workforcePeriod.map((data, index) => (
								<Select.Option key={index} value={data.id}>
									{data.name}
								</Select.Option>
							))}
						</Select>
					)}
					<br />
					<ExportToExcel data={sampleFileData} fileName='sample_file_add_position' />
				</Modal>
			</div>
		)
}

export default view(AddPositionPage)
